module.exports = __webpack_public_path__ + "media/images/application/icons/icon-mark-full-00b7fe4dca97b3bcdf38f936d0323320.svg";